define('application',[
  "lib/angular/angular.min.js",
  "lib/angular-sanitize/angular-sanitize.min.js"
], function() {
  var app = angular.module("liquor-project", ["ngSanitize"]);
  return app;
});
